import { action, flow, makeObservable, observable } from "mobx";
import {
  ApiResponse,
  GlobalStore,
  GridStore,
  UserStore,
} from "@roc/feature-app-core";
import { UploadLeadsService } from "../services/uploadLeadsService";
import { downloadDocument } from "@roc/feature-utils";

export class UploadLeadsStore {
  globalStore: GlobalStore;
  gridStore: GridStore;
  isUploadLeadsModalOpen = false;
  fileMetaData: any;
  owners: any[];
  private uploadLeadsService: UploadLeadsService;

  constructor(globalStore: GlobalStore) {
    this.globalStore = globalStore;
    this.uploadLeadsService = new UploadLeadsService();
    this.gridStore = new GridStore(() => this.fetchEventsData());
    makeObservable(this, {
      isUploadLeadsModalOpen: observable,
      setUploadLeadsModalOpen: action,
      handleDownloadTemplate: flow,
      handleUpload: flow,
      getFileMetaData: flow,
      fileMetaData: observable,
      owners: observable,
      setOwners: action
    });
  }

  setOwners(value){
    this.owners = value;
  }

  setUploadLeadsModalOpen(value) {
    this.isUploadLeadsModalOpen = value;
  }

  *handleDownloadTemplate() {
    try {
      const response: ApiResponse = yield this.uploadLeadsService.getTemplate();
      downloadDocument(
        response.data,
        response.headers,
        "download",
        `template.xlsx`,
      );
    } catch (error) {
      this.globalStore.notificationStore.showErrorNotification({
        message: "Error downloading template",
      });
      console.error("Error downloading template:", error);
    }
  }

  *handleUpload(file, name, brand, eventPlace, owners) {
    try {
      const response: ApiResponse =
        yield this.uploadLeadsService.uploadLeadsFile(
          file,
          name,
          brand,
          eventPlace,
          owners
        );
      if (response?.data?.error) {
        this.globalStore.notificationStore.showErrorNotification({
          message: response?.data?.error?.message,
        });
      } else {
        this.globalStore.notificationStore.showSuccessNotification({
          message:
            "Uploading Leads, we will notify when all leads are uploaded in the system",
        });
        this.isUploadLeadsModalOpen = false;
      }
    } catch (error) {
      this.globalStore.notificationStore.showErrorNotification({
        message: "Error while processing the file, please contact tech team",
      });
      console.error("Upload failed:", error);
    }
  }

  private async fetchEventsData() {
    try {
      const response: ApiResponse =
        await this.uploadLeadsService.getAllUploadEvents(
          this.gridStore.gridData.meta.filters,
          this.gridStore.gridData.meta.page,
          this.gridStore.gridData.meta.pageSize,
          this.gridStore.gridData.meta.sortBy,
          this.gridStore.gridData.meta.sortDir,
        );
      return response;
    } catch (error) {
      this.globalStore.notificationStore.showErrorNotification({
        message: "Error while fetching lead upload events",
      });
    }
  }

    *getFileMetaData(file) {
    try {
      const response: ApiResponse = yield this.uploadLeadsService.getFileMetaData(file);
      this.fileMetaData = response.data;
    } catch (error) {
      this.globalStore.notificationStore.showErrorNotification({
        message: "Error while processing the file",
      });
      console.error("Error while processing the file:", error);
    }
  }
}
export default UploadLeadsStore;
